import { DocumentNode } from 'graphql';
import {
  gql, QueryHookOptions, useLazyQuery, useQuery,
} from '@apollo/client';
import { IOrderSchemaPartial, IOrderSchema } from '../../type/order';
import { IWithPagination, DeepPartial } from '../_module/baseQueryType';



export interface IOrderVars {
  
 filter: {
  _id?: string;
  _ids?: string[];
  type?: string;
  referenceType?: string;
  referenceId?: string;
  buyerContactUserId?: string;
  sellerUserId?: string;
  buyerContactCompanyId?: string;
  sellerCompanyId?: string;
  buyerContactCompanyIdNotExists?: boolean;
}
 sort: {
  _id?: number;
  updatedTime?: number;
  createdTime?: number;
}
 search: {
  _id?: string;
  sellerCompanyName?: string;
  buyerContactUserFirstName?: string;
  buyerContactCompanyName?: string;
}
 skip?: number
 limit?: number
 
  
  
  
  
 
}
export const OrderQueryTypeDefinitionKey = 'Order';
export type IOrderVarsPartial = Partial<IOrderVars>
export type IOrderDataPartial = DeepPartial<IOrderSchemaPartial>
export interface IOrderQueryData<TData extends IOrderSchema = IOrderSchema>{
  

    orders: IWithPagination<TData>
}

export function orderQuery(fragment: string, rootFragment?: string, withPagination?: boolean): DocumentNode {
  return gql`
        query 

    orders(
        $filter: OrderQueryFilterParameterInput,
$search: OrderQuerySearchParameterInput,
$sort: OrderQuerySortParameterInput,
$skip: Int,
$limit: Int
        ){
        

    orders(
        filter: $filter,
search: $search,
sort: $sort,
skip: $skip,
limit: $limit
        ){
          items {
              ${fragment}
          }
          ${withPagination ? `
          pagination {
            total
            perPage
            currentPage
            hasNextPage
            totalPage
          }
          ` : ''}
          ${rootFragment || ''}
        }
        }
    `;
}

export function useOrderLazyQuery<TData extends IOrderSchema>(
  fragment: string,
  options?: QueryHookOptions<IOrderQueryData<TData>, IOrderVarsPartial>,
  rootFragment?: string,
  withPagination?: boolean
) {
  return useLazyQuery<IOrderQueryData<TData>, IOrderVarsPartial>(orderQuery(fragment, rootFragment, withPagination), options);
}

export function useOrderQuery<TData extends IOrderSchema>(
  fragment: string,
  options?: QueryHookOptions<IOrderQueryData<TData>, IOrderVarsPartial>,
  rootFragment?: string,
  withPagination?: boolean
) {
  return useQuery<IOrderQueryData<TData>, IOrderVarsPartial>(orderQuery(fragment, rootFragment, withPagination), options);
}
